var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5729 43.75H10.4167C9.3116 43.75 8.25179 43.311 7.47039 42.5296C6.68899 41.7482 6.25 40.6884 6.25 39.5833V14.5833C6.25 13.4783 6.68899 12.4185 7.47039 11.6371C8.25179 10.8557 9.3116 10.4167 10.4167 10.4167H35.4167C36.5217 10.4167 37.5815 10.8557 38.3629 11.6371C39.1443 12.4185 39.5833 13.4783 39.5833 14.5833V22.9167H6.25M31.25 6.25V14.5833M14.5833 6.25V14.5833M37.5 34.3667V37.5L39.5833 39.5833M29.1667 37.5C29.1667 39.7101 30.0446 41.8298 31.6074 43.3926C33.1702 44.9554 35.2899 45.8333 37.5 45.8333C39.7101 45.8333 41.8298 44.9554 43.3926 43.3926C44.9554 41.8298 45.8333 39.7101 45.8333 37.5C45.8333 35.2899 44.9554 33.1702 43.3926 31.6074C41.8298 30.0446 39.7101 29.1667 37.5 29.1667C35.2899 29.1667 33.1702 30.0446 31.6074 31.6074C30.0446 33.1702 29.1667 35.2899 29.1667 37.5Z",
    stroke: "#FF7402",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarTime);
export default __webpack_public_path__ + "static/media/calendar-time.a3cda33d9920637fb57ad50782ac34a9.svg";
export { ForwardRef as ReactComponent };